export const CONTENT_DELIVERY_GATEWAY_PREFIX = '/api/content-delivery';

const stripTrailingSlash = (value: string) => value.replace(/\/$/, '');

/**
 * Origin for this client only.
 * `CMS_DELIVERY_API_BASE_URL` (direct CMS) wins over the gateway `CONTENT_DELIVERY_API_BASE_URL`.
 */
export const getContentDeliveryBaseUrl = (): string => (
  process.env['CMS_DELIVERY_API_BASE_URL']
  || process.env['CONTENT_DELIVERY_API_BASE_URL']
  || process.env['NEXT_PUBLIC_CONTENT_DELIVERY_API_BASE_URL']
  || ''
);

/**
 * Prefix for `/media` URLs in CMS markup.
 * Direct CMS serves media on the CMS origin; the gateway prefixes `/api/content-delivery`.
 */
export const getUmbracoMediaBaseUrl = (): string => {
  const cmsBase = process.env['CMS_DELIVERY_API_BASE_URL'];
  if (cmsBase) return stripTrailingSlash(cmsBase);

  const gatewayBase = process.env['CONTENT_DELIVERY_API_BASE_URL']
    || process.env['NEXT_PUBLIC_CONTENT_DELIVERY_API_BASE_URL'];

  if (!gatewayBase) return '';

  return `${stripTrailingSlash(gatewayBase)}${CONTENT_DELIVERY_GATEWAY_PREFIX}`;
};

/**
 * Generated OpenAPI paths include `/api/content-delivery`. Strip it for direct CMS.
 * Used by the fetch overlay in `install-content-delivery-client.ts`, not by generated code.
 */
export const rewriteContentDeliveryRequestUrl = (url: string, base: string): string => {
  const cmsBase = process.env['CMS_DELIVERY_API_BASE_URL'];
  if (!cmsBase || !base) return url;

  const normalizedCms = stripTrailingSlash(cmsBase);
  if (stripTrailingSlash(base) !== normalizedCms) return url;

  const prefix = `${normalizedCms}${CONTENT_DELIVERY_GATEWAY_PREFIX}`;
  if (!url.startsWith(prefix)) return url;

  return `${normalizedCms}${url.slice(prefix.length)}`;
};
